import { InitialUserDetailsService } from '@coach-bot/data-access/auth/services/initial-user-details.service';
import { CopilotScriptsService } from '@coach-bot/data-access/copilot-scripts/services/copilot-scripts.service';
import { AppSyncService } from '@coach-bot/data-access/shared/services/app-sync.service';
import { StudentService } from '@coach-bot/data-access/student/services/student.service';
import { AnalyticsService } from '@coach-bot/features/analytics';
import { LearningService } from '@coach-bot/features/student/services/learning.service';
import { StudentWatchService } from '@coach-bot/features/student/services/student-watch.service';
import { StudentState } from '@coach-bot/features/student/states/student-state';
import { TimecardTrackingService } from '@coach-bot/features/tracking/services/timecard-tracking-service';
import { Environment, initializeEnvironment } from '@environment';
import { CoachBotUserStore, CoachBotViewStore, CommonStore, StudentStore } from '../store';
import { ApiRequestService } from './api-request.service';
import { AuthService } from './auth.service';
import { ContextMenuService } from './context-menu.service';
import { HeartbeatService } from './heartbeat.service';
import { LocalStorageService } from './local-storage.service';
import { ServiceWorkerStatusService } from './service-worker-status.service';
import { ServiceWorkerSubscriptionsService } from './service-worker-subscriptions.service';
import { NetworkService } from './network.service';

export class Services {
  readonly analyticsService: AnalyticsService;
  readonly apiRequestService: ApiRequestService;
  readonly appSyncService: AppSyncService;
  readonly authService: AuthService;
  readonly coachBotUserStore: CoachBotUserStore;
  readonly coachBotViewStore: CoachBotViewStore;
  readonly commonStore: CommonStore;
  readonly contextMenuService: ContextMenuService;
  readonly copilotScriptsService: CopilotScriptsService;
  readonly environment: Environment;
  readonly heartbeatService: HeartbeatService;
  readonly initialUserDetailsService: InitialUserDetailsService;
  readonly learningService: LearningService;
  readonly localStorageService: LocalStorageService;
  readonly networkService: NetworkService;
  readonly serviceWorkerStatusService: ServiceWorkerStatusService;
  readonly serviceWorkerSubscriptionsService: ServiceWorkerSubscriptionsService;
  readonly studentService: StudentService;
  readonly studentState: StudentState;
  readonly studentStore: StudentStore;
  readonly studentWatchService: StudentWatchService;
  readonly timecardTrackingService: TimecardTrackingService;

  constructor() {
    this.environment = initializeEnvironment();

    this.analyticsService = new AnalyticsService();
    this.apiRequestService = new ApiRequestService(this);
    // Disable AppSyncService in beyond.ai extension
    // this.appSyncService = new AppSyncService(this.environment);
    this.authService = new AuthService(this);
    this.contextMenuService = new ContextMenuService(this);
    this.copilotScriptsService = new CopilotScriptsService(this.appSyncService);
    this.heartbeatService = new HeartbeatService(this);
    this.initialUserDetailsService = new InitialUserDetailsService();
    this.localStorageService = new LocalStorageService();
    this.networkService = new NetworkService(this);
    this.serviceWorkerStatusService = new ServiceWorkerStatusService(this);
    this.serviceWorkerSubscriptionsService = new ServiceWorkerSubscriptionsService(this);
    this.timecardTrackingService = new TimecardTrackingService();

    this.coachBotUserStore = new CoachBotUserStore(this.localStorageService);
    this.coachBotViewStore = new CoachBotViewStore(this.localStorageService);
    this.commonStore = new CommonStore(this.localStorageService);
    this.studentService = new StudentService(this.apiRequestService);
    this.studentStore = new StudentStore(this.localStorageService);
    this.studentState = new StudentState(
      this.analyticsService,
      this.commonStore.profileEmail$,
      this.studentService,
      this.studentStore,
      this.commonStore.userId$
    );

    this.learningService = new LearningService(
      this.apiRequestService,
      this.commonStore.lastSignInTime$,
      this.studentState,
      this.studentStore
    );
    this.studentWatchService = new StudentWatchService(
      this.commonStore.isExtensionPopupOpened$,
      this.commonStore.isSignedIn$,
      this.learningService,
      this.commonStore.profileEmail$,
      this.studentState,
      this.studentStore,
      this.commonStore.userDetails$
    );
  }
}
